import React from 'react';

export default function SectionLabel({ children }) {
  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-blue-500/25 bg-blue-500/[0.04] px-3 py-1.5 text-[11px] uppercase tracking-[0.22em] text-blue-600">
      <span className="h-1.5 w-1.5 rounded-full bg-blue-500 shadow-[0_0_10px_rgba(37,99,235,0.9)]" />
      {children}
    </div>
  );
}
